export default __webpack_public_path__ + "static/logo-mgh-42eb92f49264cee9c24d906a353e2267.png";